import CancelSession from '../../../guidanceSessions/components/CancelSession';

export default function CancelSessionScreen() {
    return <CancelSession />;
}
